import React from 'react'
import HeroSection from '../HeroSection'
import RenovationSection from './Renvoation/RenovationSection'

const Home = () => {
  return (
    <div className=''>
        <HeroSection/>
        {/* Other components */}
        <RenovationSection/>
    </div>
  )
}

export default Home
